import { createSlice } from '@reduxjs/toolkit'
import { getUserAuthority } from 'utils/permissionUtils'

export const initialState = {
    avatar: '',
    username: '',
    email: '',
    authority: [],
}

export const userSlice = createSlice({
    name: 'auth/user',
    initialState,
    reducers: {
        setUser: (_, action) => {
            const user = action.payload || initialState
            return {
                ...user,
                authority: getUserAuthority(user),
            }
        },
        userLoggedOut: () => initialState,
    },
})

export const { setUser } = userSlice.actions

export default userSlice.reducer
